<table
        (matSortChange)="onSortChange($event)"

        [dataSource]="dataSource"

        mat-table
        matSort
        style="width: 100%"
>
    <!-- <ng-container matColumnDef="action">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
       N°
      </th>
      <td *matCellDef="let d; let i = index;" mat-cell> {{i+1}}</td>
    </ng-container>

    <ng-container matColumnDef="lawClCd">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
        {{ "lawClCd" | translate }}
      </th>
      <td *matCellDef="let d" mat-cell>{{ d.lawClCd }}</td>
    </ng-container>
    -->

    <ng-container>
        <ng-container matColumnDef="cdNm">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
                {{ "cdNm" | translate }}
            </th>
            <td *matCellDef="let d" mat-cell><span>{{ d.cdNm }}</span></td>
        </ng-container>

        <ng-container matColumnDef="cdNmFr">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
                {{ "cdNm" | translate }}
            </th>
            <td *matCellDef="let d" mat-cell><span>{{ d.cdNmFr }}</span></td>
        </ng-container>

        <ng-container matColumnDef="cdNmAr">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
                {{ "cdNm" | translate }}
            </th>
            <td *matCellDef="let d" mat-cell><span>{{ d.cdNmAr }}</span></td>
        </ng-container>
        <ng-container matColumnDef="title">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>

                {{ "title1" | translate}}
            </th>
            <td *matCellDef="let d" mat-cell>
                <span>{{ d.title }}</span>
                <!--     <a [routerLink]="['/portail/administrator-announcements/details']"  [queryParams]="{ id: d.ptNoticeOptId }" class="st-p" >-->
                <!--     {{ d.title }}</a>-->
            </td>
        </ng-container>

        <ng-container matColumnDef="moderNm">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
                {{ "moderNm" | translate }}
            </th>
            <td *matCellDef="let d" mat-cell><span>{{ d.writerNm }}</span></td>
        </ng-container>


        <ng-container matColumnDef="modDt">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
                {{ "modDt" | translate }}
            </th>
            <td class="text-center" *matCellDef="let d" mat-cell><span>{{ d.modDt | df }}</span></td>
        </ng-container>


        <ng-container matColumnDef="hitCnt">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
                {{ "hitCnt" | translate }}
            </th>
            <td class="text-center" *matCellDef="let d" mat-cell><span>{{ d.hitCnt }}</span></td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell></th>
            <td class="text-center" *matCellDef="let d" mat-cell>
                <a (click)="openDetails(d)" mat-icon-button>
                    <mat-icon style="color: #00a8ff;">info</mat-icon>
                </a>
            </td>
        </ng-container>


        <!--  <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">

           <th *matHeaderCellDef mat-header-cell mat-sort-header>
             {{ column | translate }}
           </th>

           <td *matCellDef="let type" mat-cell>
             {{ type[column] | typedValue | async }}
           </td>
         </ng-container> -->
        <tr *matHeaderRowDef="getcol()" mat-header-row></tr>
        <tr *matRowDef="let row; columns: getcol()" mat-row></tr>

    </ng-container>




</table>
<app-spinner-container [isLoading]="list == undefined || list == null">
</app-spinner-container>
<app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>

